import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Version {
  version: string;
  verified: boolean;
  changed: boolean;
  diffs: Array<{ id: string; type: string; summary: string }>;
}

interface VersionsState {
  versions: Version[];
  loading: boolean;
  error: string | null;
  currentSlug: string | null;
  selectedVersion: string | null;
}

const initialState: VersionsState = {
  versions: [],
  loading: false,
  error: null,
  currentSlug: null,
  selectedVersion: null
};

const versionsSlice = createSlice({
  name: 'versions',
  initialState,
  reducers: {
    setVersions: (state, action: PayloadAction<Version[]>) => {
      state.versions = action.payload;
      state.loading = false;
      state.error = null;
    },
    setVersionsLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setVersionsError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.loading = false;
    },
    setCurrentSlug: (state, action: PayloadAction<string | null>) => {
      state.currentSlug = action.payload;
    },
    clearVersions: (state) => {
      state.versions = [];
      state.loading = false;
      state.error = null;
      state.currentSlug = null;
      state.selectedVersion = null;
    },
    setSelectedVersion: (state, action: PayloadAction<string | null>) => {
      state.selectedVersion = action.payload;
    }
  }
});

export const {
  setVersions,
  setVersionsLoading,
  setVersionsError,
  setCurrentSlug,
  clearVersions,
  setSelectedVersion
} = versionsSlice.actions;

export default versionsSlice.reducer;
